jQuery(document).ready(function($) {
    $('#changeable-password-form').submit(function(event) {
        event.preventDefault();
        var oldPassword = $('#changeable-old-password');
        var newPassword = $('#changeable-new-password'); // Використовуємо jQuery-об'єкт для поля нового пароля
        var confirmPassword = $('#changeable-new-password-confirm');
        var userEmail = $('#changeable-password').data('email');


        var isFormValid = true;
        var errorMessage = '';
        // Перевіряємо заповненість полів
        if (!newPassword.val() && !confirmPassword.val() && !oldPassword.val()) {
            errorMessage = localized_texts.enter_fields;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            newPassword.addClass('error');
            confirmPassword.addClass('error');
            oldPassword.addClass('error')
            isFormValid = false;
        } else if(!newPassword.val() && !confirmPassword.val()) {
            errorMessage = localized_texts.enter_fields;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            newPassword.addClass('error');
            confirmPassword.addClass('error');
            isFormValid = false;
        } else if(!oldPassword.val()) {
            errorMessage = localized_texts.enter_old_password;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            oldPassword.addClass('error');
            isFormValid = false;
        } else if(!newPassword.val()){
            errorMessage = localized_texts.enter_new_password;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            newPassword.addClass('error');
            isFormValid = false;
        } else if(!confirmPassword.val()) {
            errorMessage = localized_texts.confirm_password;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            confirmPassword.addClass('error');
            isFormValid = false;
        }

        if (newPassword.val() !== confirmPassword.val()) {
            errorMessage = localized_texts.passwords_do_not_match;
            displayNotification(errorMessage, false, 3);
            removeErrorClass();
            confirmPassword.addClass('error');
            newPassword.addClass('error');
            isFormValid = false;
        }


        if (isFormValid) {
            $.ajax({
                type: 'POST',
                url: ajax_changeable.ajax_url, // URL адреса для AJAX запиту
                data: {
                    action: 'changeable_password',
                    old_password: oldPassword.val(),
                    new_password: newPassword.val(),
                    user_email: userEmail,
                },
                success: function (response) {
                    var jsonResponse = JSON.parse(response);
                    if (jsonResponse.success){
                        removeErrorClass();
						if(jsonResponse.class){
							oldPassword.addClass('error')
						}
                        displayNotification(jsonResponse.message, jsonResponse.success, 2);
                        setTimeout(function() { // Додаємо затримку перед оновленням HTML
                            location.reload();
                        }, 2100); // Затримка 3.1 секунди
                    } else{
                        displayNotification(jsonResponse.message, jsonResponse.success, 3);
                        if (jsonResponse.field) {
                            removeErrorClass();
                            $('#' + jsonResponse.field).addClass('error');
                        }
                    }
                }
            });
        }
    });
    function displayNotification(message, isSuccess, durationInSeconds = 15) {
        var notificationElement = $('.modal_notification');
        notificationElement.text(message).addClass('visible');
        if (!isSuccess) {
            notificationElement.addClass('error');
        } else {
            notificationElement.removeClass('error').addClass('success');
        }
        setTimeout(function() {
            notificationElement.removeClass('visible error success');
        }, durationInSeconds * 1000); // 15 секунд
    }

    function removeErrorClass() {
        var errorElement = document.querySelectorAll('.modal_form .error'); // Отримуємо всі елементи введення з класом помилки
        errorElement.forEach(function(input) { // Ітеруємося по кожному елементу
            input.classList.remove('error'); // Видаляємо клас помилки
        });
    }
});


